define('uikit/collections/checkbox.group',['require','exports','module','marionette','underscore','../channel','../mixins/component.mixin','../elements/checkbox','../views/proxy.options.view'],function(require, exports, module) {
  var Mn = require('marionette');
  var _ = require('underscore');
  var channel = require('../channel');
  var ComponentMixin = require('../mixins/component.mixin');
  var Checkbox = require('../elements/checkbox');
  var ProxyOptionsView = require('../views/proxy.options.view');

  var CheckboxGroup = Mn.CollectionView.extend(ComponentMixin).extend({
    childView: Checkbox,

    className: 'grouped fields',

    getChildView: function() {
      return ProxyOptionsView.extend({
        className: 'field',
        proxyView: this.getOption('childView'),
      });
    },

    childViewOptions: function() {
      return {
        useViewIdAsId: true,
        useLabel: true,
        radio: this.getBoolOption('radio'),
        bindings: _.clone(this.childBindings),
      };
    },

    options: {
      visible: true,
      value: null,
      inline: false,
      radio: false,
    },

    bindings: {},

    onFirstRender: function() {
      this.updateElementAttributes({ role: this.getOption('radio') ? 'radiogroup' : 'group' });

      this.on(
        'change:value',
        function() {
          if (this.getOption('radio')) {
            this.updateChildCheckboxes();
          }
        },
        this
      );

      this.on(
        'childview:change:value',
        function(view, value, previous, options) {
          if (this.getOption('radio')) {
            if (view.value === true && !this.getOption('internal')) {
              this.value = view.model;
            }
          } else {
            if (view.value === true) {
              this.value.add(view.model);
            } else {
              this.value.remove(view.model);
            }
          }
        },
        this
      );

      this.on(
        'before:add:child',
        function(view) {
          if (this.getBoolOption('radio')) {
            view.value = view.model === this.value;
          } else if (this.value instanceof Backbone.Collection) {
            if (this.value.contains(view.model)) {
              view.value = true;
            }
          }
        },
        this
      );

      this.initializeValue();
    },

    // we nee to setup the internal value option based on
    // where we are in checkbox mode or not
    // if the "radio" option is true then "value" will be
    // a regular Backbone Model.  If "radio" option is false
    // then value will be a collection of the selected checkbox
    // models
    initializeValue: function() {
      if (this.getOption('radio')) {
        var model = this.value;
        if (model && model instanceof Backbone.Collection) {
          this.stopListening(model);
          // we need to trigger on both event systems;
          this._setOption('value', model.at(0));
        } else if (model && model instanceof Backbone.Model) {
          this._setOption('value', model);
        } else {
          this._setOption('value', null);
        }

        if (!this.value) {
          this.children.any(function(view) {
            if (view.value === true) {
              this.value = view.model;
              return true;
            }
          }, this);
        }
      } else {
        var model = this.value;
        var toAdd = [];

        this.children.each(function(view) {
          if (view.value === true) {
            toAdd.push(view.model);
          }
        }, this);

        if (!(model instanceof Backbone.Collection)) {
          this.value = new Backbone.Collection(toAdd);
        } else {
          this.value.add(toAdd);
        }

        this.listenTo(this.value, 'add remove reset change update', _.debounce(this.updateChildCheckboxes, 10));
        this.listenTo(this.value, 'add remove reset change update', function() {
          // manually trigger change value so other things know that it has changed
          this.trigger('change:value', this, this.value, this.value, {
            previousValue: this.value,
          });
          this.trigger('change', this, 'value', this.value, this.value, {
            previousValue: this.value,
          });
        });

        if (model && model instanceof Backbone.Model) {
          this.value.add(model);
        }
      }

      this.updateChildCheckboxes();

      this.collection.each(function(child) {
        var view = this.children.findByModel(child);
        if (view) {
          view.radio = this.getOption('radio');
        }
      }, this);
    },

    // when we are in checkbox mode and an item in the collection changes
    // we need to set the value on each of our views to match what is in
    // the value collection
    updateChildCheckboxes: function() {
      this.children.each(function(view) {
        if (this.getBoolOption('radio')) {
          if (this.value === view.model) {
            view._setOption('value', true, { internal: true });
          } else {
            view._setOption('value', false, { internal: true });
          }
        } else if (this.value instanceof Backbone.Collection) {
          if (this.value.contains(view.model)) {
            view.value = true;
          } else {
            view.value = false;
          }
        }
      }, this);
    },

    updateAttributes: function() {
      this.addClass('inline', this.getOption('inline'));
    },
  });

  channel.reply('checkbox-group', function() {
    return CheckboxGroup;
  });

  module.exports = CheckboxGroup;
});

